(function (window, document) {
    'use strict';

    var dropZoneStateKey = '__documentDropZoneState';

    function assignFiles(fileInput, files) {
        if (!fileInput || !files) {
            return;
        }

        var dataTransfer = new DataTransfer();

        Array.prototype.forEach.call(files, function (file) {
            dataTransfer.items.add(file);
        });

        fileInput.files = dataTransfer.files;
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    window.initDocumentDropZone = function initDocumentDropZone(options) {
        if (!options) {
            return;
        }

        var dropZone = typeof options.dropZone === 'string'
            ? document.querySelector(options.dropZone)
            : options.dropZone;
        var fileInput = typeof options.fileInput === 'string'
            ? document.querySelector(options.fileInput)
            : options.fileInput;
        var browseButton = typeof options.browseButton === 'string'
            ? document.querySelector(options.browseButton)
            : options.browseButton;

        if (!dropZone || !fileInput) {
            return;
        }

        if (dropZone[dropZoneStateKey] && typeof dropZone[dropZoneStateKey].dispose === 'function') {
            dropZone[dropZoneStateKey].dispose();
        }

        function openPicker() {
            fileInput.click();
        }

        function preventDefaults(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        function setDragState(isActive) {
            dropZone.classList.toggle('document-drop-zone--dragover', isActive);
        }

        function handleDragEnter() {
            setDragState(true);
        }

        function handleDragOver() {
            setDragState(true);
        }

        function handleDragLeave(event) {
            if (!dropZone.contains(event.relatedTarget)) {
                setDragState(false);
            }
        }

        function handleDrop(event) {
            setDragState(false);
            var files = event.dataTransfer ? event.dataTransfer.files : null;
            if (files && files.length > 0) {
                assignFiles(fileInput, files);
            }
        }

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
            dropZone.addEventListener(eventName, preventDefaults);
        });

        dropZone.addEventListener('dragenter', handleDragEnter);
        dropZone.addEventListener('dragover', handleDragOver);
        dropZone.addEventListener('dragleave', handleDragLeave);
        dropZone.addEventListener('drop', handleDrop);

        var handleBrowseClick = null;
        if (browseButton) {
            handleBrowseClick = function (event) {
                event.preventDefault();
                event.stopPropagation();
                openPicker();
            };

            browseButton.addEventListener('click', handleBrowseClick);
        }

        function handleClick(event) {
            if (event.target.closest('[data-drop-zone-browse]')) {
                return;
            }

            openPicker();
        }

        dropZone.addEventListener('click', handleClick);

        dropZone[dropZoneStateKey] = {
            dispose: function () {
                ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
                    dropZone.removeEventListener(eventName, preventDefaults);
                });

                dropZone.removeEventListener('dragenter', handleDragEnter);
                dropZone.removeEventListener('dragover', handleDragOver);
                dropZone.removeEventListener('dragleave', handleDragLeave);
                dropZone.removeEventListener('drop', handleDrop);
                dropZone.removeEventListener('click', handleClick);

                if (browseButton && handleBrowseClick) {
                    browseButton.removeEventListener('click', handleBrowseClick);
                }
            }
        };

        return dropZone[dropZoneStateKey];
    };

    function initializeFromElement(element) {
        if (!element || element.dataset.documentDropZoneInitialized === 'true') {
            return element ? element[dropZoneStateKey] || null : null;
        }

        var options = {
            dropZone: element,
            fileInput: element.getAttribute('data-document-drop-zone-file-input'),
            browseButton: element.getAttribute('data-document-drop-zone-browse-button'),
        };

        var state = window.initDocumentDropZone(options);
        if (!state) {
            return null;
        }

        element.dataset.documentDropZoneInitialized = 'true';

        return state;
    }

    function scanForAutoInitialization(root) {
        if (!root || typeof root.querySelectorAll !== 'function') {
            return;
        }

        if (typeof root.matches === 'function' && root.matches('[data-document-drop-zone-file-input]')) {
            initializeFromElement(root);
        }

        root.querySelectorAll('[data-document-drop-zone-file-input]').forEach(initializeFromElement);
    }

    function startAutoInitialization() {
        scanForAutoInitialization(document);

        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node && node.nodeType === 1) {
                        scanForAutoInitialization(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startAutoInitialization, { once: true });
    } else {
        startAutoInitialization();
    }
})(window, document);
